import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '..';
import {
  MissingLumberPriceRow,
  MissingOptimizerPricesState,
  MissingPlatePriceRow,
} from '../slices/optimizationSettingsSlice';
import { getActiveComponentDesignGuid } from './getActiveComponentDesignSelector';

const NO_LUMBER_ROWS: readonly MissingLumberPriceRow[] = [];
const NO_PLATE_ROWS: readonly MissingPlatePriceRow[] = [];
const IDLE: MissingOptimizerPricesState = { status: 'idle' };

const getMissingOptimizerPricesForActiveComponent = createSelector(
  (state: RootState) => state.optimizationSettings.missingOptimizerPrices,
  getActiveComponentDesignGuid,
  (missingOptimizerPrices, activeComponentDesignGuid): MissingOptimizerPricesState => {
    if (missingOptimizerPrices.status === 'idle') return missingOptimizerPrices;
    return missingOptimizerPrices.componentDesignGuid === activeComponentDesignGuid ? missingOptimizerPrices : IDLE;
  },
);

export const getMissingLumberPriceRowsForActiveComponent = createSelector(
  getMissingOptimizerPricesForActiveComponent,
  (missingOptimizerPrices): readonly MissingLumberPriceRow[] =>
    missingOptimizerPrices.status === 'loaded' ? missingOptimizerPrices.lumberRows : NO_LUMBER_ROWS,
);

export const getMissingPlatePriceRowsForActiveComponent = createSelector(
  getMissingOptimizerPricesForActiveComponent,
  (missingOptimizerPrices): readonly MissingPlatePriceRow[] =>
    missingOptimizerPrices.status === 'loaded' ? missingOptimizerPrices.plateRows : NO_PLATE_ROWS,
);

export const getMissingOptimizerPricesStatusForActiveComponent = createSelector(
  getMissingOptimizerPricesForActiveComponent,
  (missingOptimizerPrices): MissingOptimizerPricesState['status'] => missingOptimizerPrices.status,
);
